import { MapDialog } from "./MapDialog";
import { html } from "lit-html";
import unsaferHTML from "@escapio/shared/unsaferHTML";
import { translate } from "../../../shared/l10n/translate";
import { data } from "@escapio/shared/state/payload";
import { store } from "../hotel-list/DataStore";
import { not } from "../../../shared/util/function";
import { track } from "../../tracker/EventTracker";
import { addHash } from "../hotel/add-hash";
import { format } from "../hotel/FilterToHashMapper";

import "./map-libre/HotelMap";

const isPrimary = hotel => hotel.distance === -1;
const TRACK_LABEL_SUFFIX = " (Karte)";

export class ListMapDialog extends MapDialog {
	constructor() {
		super();
		this.titleText = data.prepositionedArticleTitle;
		this.subtitleText = "";
		this.closeButtonText = translate("hotel_close_map");

		this.count = 0;
		this.hash = "";
		this.visibleHotels = [];
		this.prices = {};
		// @TODO: get hotels from data store, so any modifications
		//        like adding the hash to the hotel url can be done there.
		//        The map needs all the hotels for setting the bounds. This could be done with a new view in the DataStore.
		//        The visibleHotels property should then be superfluous.
		this.primaryHotels = data.hotel_list.filter(isPrimary);
		this.secondaryHotels = data.hotel_list.filter(not(isPrimary));

		store.subscribe(this.update.bind(this));
		this.update(store.getState(), store);
	}

	getTemplateContent() {
		return html`
			<div class="map__filters hidden-mobile hidden-tablet">
				<esc-hotel-list-price-filter-section
					track-label-suffix="${TRACK_LABEL_SUFFIX}"
					class="filter-box__section filter-box__section--sidebar filter-box__section--price"
				></esc-hotel-list-price-filter-section>
				<esc-hotel-list-board-filter
					track-label-suffix="${TRACK_LABEL_SUFFIX}"
					class="filter-box__section filter-box__section--sidebar filter-box__section--board"
				></esc-hotel-list-board-filter>
				<esc-hotel-list-score-filter
					track-label-suffix="${TRACK_LABEL_SUFFIX}"
					class="filter-box__section filter-box__section--sidebar filter-box__section--score"
					frequentUpdates
				></esc-hotel-list-score-filter>
				<esc-hotel-list-recently-used-filters
					track-label-suffix="${TRACK_LABEL_SUFFIX}"
					class="filter-box__section filter-box__section--sidebar"
				></esc-hotel-list-recently-used-filters>
				<esc-hotel-list-multi-toggle-filter
					track-label-suffix="${TRACK_LABEL_SUFFIX}"
					class="filter-box__section filter-box__section--sidebar filter-box__section--toggles"
					filterName="criteria"
				></esc-hotel-list-multi-toggle-filter>
				<esc-hotel-list-classification-filter
					track-label-suffix="${TRACK_LABEL_SUFFIX}"
					class="filter-box__section filter-box__section--sidebar filter-box__section--classification"
				></esc-hotel-list-classification-filter>
				<esc-hotel-list-multi-toggle-filter
					track-label-suffix="${TRACK_LABEL_SUFFIX}"
					class="filter-box__section filter-box__section--sidebar filter-box__section--toggles"
					filterName="hotelTypes"
				></esc-hotel-list-multi-toggle-filter>
			</div>
			<esc-maplibre-hotel-map
				track-name="Liste Karte"
				track-hotel-primary-action-suffix=" - ${data.trackingId}"
				track-hotel-secondary-action-suffix=" - ${data.trackingId}"
				init-map-includes-secondary
				.visibleHotels=${this.visibleHotels}
				.primaryHotels=${this.primaryHotels.map(addHash(this.hash))}
				.secondaryHotels=${this.secondaryHotels.map(addHash(this.hash))}
				.prices=${this.prices}
			></esc-maplibre-hotel-map>
			<header class="dialog__transparent-header">
				<div class="dialog__transparent-header__text">
					<esc-filter-dialog-button
						class="hotel-list__controls-button"
						track-label-suffix="(Karte)"
					></esc-filter-dialog-button>
				</div>
			</header>
			<div class="dialog__transparent-header__button">
				<button @click=${this.hide.bind(this)}>
					<span
						class="close-icon close-icon--large close-icon--with-hover"
					></span>
				</button>
			</div>
		`;
	}

	getTemplateHeaderMiddle() {
		return html`${super.getTemplateHeaderMiddle()}<span
				class="dialog__header-middle__count"
				>${this.count}<span></span
			></span>`;
	}

	update(state, { counters }) {
		this.count = counters.unfiltered;
		this.hash = format(state.filters);
		this.subtitleText =
			this.count === 1
				? unsaferHTML(
						translate(
							"list_map_hotel_count_singular",
							`<strong>${this.count}</strong>`,
						),
					)
				: unsaferHTML(
						translate(
							"list_map_hotel_count_plural",
							`<strong>${this.count}</strong>`,
						),
					);
		this.visibleHotels = store.visibleHotels.map(hotel => hotel.id);
		this.prices = state.prices;
		this.render();
	}

	show() {
		super.show();
		track(
			"Liste",
			"Klick Karte öffnen",
			`${data.trackingId} | ${data.prepositionedArticleTitle}`,
		);
	}
}
